/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Providers.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  AuthTokenApiContract,
  AuthTokenPairApiContract,
  EmailApiContract,
  ErrorApiOutContract,
  ErrorDescription,
  MagicLinkLoginWebApiInContract,
  OauthLoginWebApiInContract,
  PasswordLoginWebApiInContract,
  ProblemDetails,
  TokenWithPasswordApiContract
} from '../pwrdbyQuickMDProvidersApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Login using email and password.
            
# Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | AccountLocked | Account is locked, wait before trying again |
| 400 | CredentialsNotValid | Invalid auth credentialss |
| 400 | PasswordDetectedInBreach | Password detected in breach and must be changed |
| 400 | EmailNotValid | Invalid email format |
| 400 | PasswordResetRequired | Password must be reset before logging in |
| 403 | — | Endpoint disabled via feature flag |
 * @summary Email/Password login
 */
export const postAuthLogin = (
    passwordLoginWebApiInContract: PasswordLoginWebApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<AuthTokenApiContract>(
      {url: `https://providers-api.api.quick.md/api/v1/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordLoginWebApiInContract, signal
    },
      options);
    }
  


export const getPostAuthLoginMutationOptions = <TError = ErrorDescription | ProblemDetails | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthLogin>>, TError,{data: PasswordLoginWebApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthLogin>>, TError,{data: PasswordLoginWebApiInContract}, TContext> => {

const mutationKey = ['postAuthLogin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthLogin>>, {data: PasswordLoginWebApiInContract}> = (props) => {
          const {data} = props ?? {};

          return  postAuthLogin(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthLogin>>>
    export type PostAuthLoginMutationBody = PasswordLoginWebApiInContract
    export type PostAuthLoginMutationError = ErrorDescription | ProblemDetails | ErrorApiOutContract

    /**
 * @summary Email/Password login
 */
export const usePostAuthLogin = <TError = ErrorDescription | ProblemDetails | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthLogin>>, TError,{data: PasswordLoginWebApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthLogin>>,
        TError,
        {data: PasswordLoginWebApiInContract},
        TContext
      > => {

      const mutationOptions = getPostAuthLoginMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * | HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | EmailNotValid | Email is invalid |
 * @summary Request Magic Link Email
 */
export const postAuthMagiclinkRequest = (
    emailApiContract: EmailApiContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/auth/magiclink/request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emailApiContract, signal
    },
      options);
    }
  


export const getPostAuthMagiclinkRequestMutationOptions = <TError = ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthMagiclinkRequest>>, TError,{data: EmailApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthMagiclinkRequest>>, TError,{data: EmailApiContract}, TContext> => {

const mutationKey = ['postAuthMagiclinkRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthMagiclinkRequest>>, {data: EmailApiContract}> = (props) => {
          const {data} = props ?? {};

          return  postAuthMagiclinkRequest(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthMagiclinkRequestMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthMagiclinkRequest>>>
    export type PostAuthMagiclinkRequestMutationBody = EmailApiContract
    export type PostAuthMagiclinkRequestMutationError = ErrorApiOutContract

    /**
 * @summary Request Magic Link Email
 */
export const usePostAuthMagiclinkRequest = <TError = ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthMagiclinkRequest>>, TError,{data: EmailApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthMagiclinkRequest>>,
        TError,
        {data: EmailApiContract},
        TContext
      > => {

      const mutationOptions = getPostAuthMagiclinkRequestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Login using magic link is an alternative to the standard login with email and password.
            
# Error Codes
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | TokenNotValid | Invalid token |
| 400 | AccountNotVerified | Account not verified by user yet |
| 400 | AccountNotActive | Account is not active |
| 500 | InternalServerError | Internal server error |
 * @summary Magic Link Login
 */
export const postAuthMagiclinkLogin = (
    magicLinkLoginWebApiInContract: MagicLinkLoginWebApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<AuthTokenApiContract>(
      {url: `https://providers-api.api.quick.md/api/v1/auth/magiclink/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: magicLinkLoginWebApiInContract, signal
    },
      options);
    }
  


export const getPostAuthMagiclinkLoginMutationOptions = <TError = ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthMagiclinkLogin>>, TError,{data: MagicLinkLoginWebApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthMagiclinkLogin>>, TError,{data: MagicLinkLoginWebApiInContract}, TContext> => {

const mutationKey = ['postAuthMagiclinkLogin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthMagiclinkLogin>>, {data: MagicLinkLoginWebApiInContract}> = (props) => {
          const {data} = props ?? {};

          return  postAuthMagiclinkLogin(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthMagiclinkLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthMagiclinkLogin>>>
    export type PostAuthMagiclinkLoginMutationBody = MagicLinkLoginWebApiInContract
    export type PostAuthMagiclinkLoginMutationError = ErrorDescription | ErrorApiOutContract

    /**
 * @summary Magic Link Login
 */
export const usePostAuthMagiclinkLogin = <TError = ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthMagiclinkLogin>>, TError,{data: MagicLinkLoginWebApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthMagiclinkLogin>>,
        TError,
        {data: MagicLinkLoginWebApiInContract},
        TContext
      > => {

      const mutationOptions = getPostAuthMagiclinkLoginMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Login using OAuth token provided by Stytch
            
# Error Codes
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | TokenNotValid | Invalid token |
| 400 | AccountNotVerified | Account not verified by user yet |
| 400 | AccountNotActive | Account is not active |
| 500 | InternalServerError | Internal server error |
 * @summary Oauth Login
 */
export const postAuthOauthLogin = (
    oauthLoginWebApiInContract: OauthLoginWebApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<AuthTokenApiContract>(
      {url: `https://providers-api.api.quick.md/api/v1/auth/oauth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: oauthLoginWebApiInContract, signal
    },
      options);
    }
  


export const getPostAuthOauthLoginMutationOptions = <TError = ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthOauthLogin>>, TError,{data: OauthLoginWebApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthOauthLogin>>, TError,{data: OauthLoginWebApiInContract}, TContext> => {

const mutationKey = ['postAuthOauthLogin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthOauthLogin>>, {data: OauthLoginWebApiInContract}> = (props) => {
          const {data} = props ?? {};

          return  postAuthOauthLogin(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthOauthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthOauthLogin>>>
    export type PostAuthOauthLoginMutationBody = OauthLoginWebApiInContract
    export type PostAuthOauthLoginMutationError = ErrorDescription | ErrorApiOutContract

    /**
 * @summary Oauth Login
 */
export const usePostAuthOauthLogin = <TError = ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthOauthLogin>>, TError,{data: OauthLoginWebApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthOauthLogin>>,
        TError,
        {data: OauthLoginWebApiInContract},
        TContext
      > => {

      const mutationOptions = getPostAuthOauthLoginMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | TokenNotValid | Invalid token |
| 429 | TooManyRequests | Too many requests, wait before trying again |
 * @summary Exchange auth token for a new one.
 */
export const postAuthRefreshtoken = (
    authTokenApiContract: AuthTokenApiContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<AuthTokenPairApiContract>(
      {url: `https://providers-api.api.quick.md/api/v1/auth/refreshtoken`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authTokenApiContract, signal
    },
      options);
    }
  


export const getPostAuthRefreshtokenMutationOptions = <TError = ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRefreshtoken>>, TError,{data: AuthTokenApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthRefreshtoken>>, TError,{data: AuthTokenApiContract}, TContext> => {

const mutationKey = ['postAuthRefreshtoken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthRefreshtoken>>, {data: AuthTokenApiContract}> = (props) => {
          const {data} = props ?? {};

          return  postAuthRefreshtoken(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthRefreshtokenMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthRefreshtoken>>>
    export type PostAuthRefreshtokenMutationBody = AuthTokenApiContract
    export type PostAuthRefreshtokenMutationError = ErrorDescription | ErrorApiOutContract

    /**
 * @summary Exchange auth token for a new one.
 */
export const usePostAuthRefreshtoken = <TError = ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRefreshtoken>>, TError,{data: AuthTokenApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthRefreshtoken>>,
        TError,
        {data: AuthTokenApiContract},
        TContext
      > => {

      const mutationOptions = getPostAuthRefreshtokenMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | TokenNotValid | Invalid token |
| 429 | TooManyRequests | Too many requests, wait before trying again |
 * @summary Verify email address.
 */
export const putAuthVerifyemail = (
    tokenWithPasswordApiContract: TokenWithPasswordApiContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<EmailApiContract>(
      {url: `https://providers-api.api.quick.md/api/v1/auth/verifyemail`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: tokenWithPasswordApiContract
    },
      options);
    }
  


export const getPutAuthVerifyemailMutationOptions = <TError = ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAuthVerifyemail>>, TError,{data: TokenWithPasswordApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putAuthVerifyemail>>, TError,{data: TokenWithPasswordApiContract}, TContext> => {

const mutationKey = ['putAuthVerifyemail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAuthVerifyemail>>, {data: TokenWithPasswordApiContract}> = (props) => {
          const {data} = props ?? {};

          return  putAuthVerifyemail(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAuthVerifyemailMutationResult = NonNullable<Awaited<ReturnType<typeof putAuthVerifyemail>>>
    export type PutAuthVerifyemailMutationBody = TokenWithPasswordApiContract
    export type PutAuthVerifyemailMutationError = ErrorDescription | ErrorApiOutContract

    /**
 * @summary Verify email address.
 */
export const usePutAuthVerifyemail = <TError = ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAuthVerifyemail>>, TError,{data: TokenWithPasswordApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAuthVerifyemail>>,
        TError,
        {data: TokenWithPasswordApiContract},
        TContext
      > => {

      const mutationOptions = getPutAuthVerifyemailMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | AccountLocked | Account locked temporarily, wait before trying again |
| 400 | EmailNotValid | Invalid email format |
| 400 | EmailUndeliverable | Email undeliverable/bounced |
 * @summary Send forgot password email
 */
export const postAuthForgotpassword = (
    emailApiContract: EmailApiContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/auth/forgotpassword`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emailApiContract, signal
    },
      options);
    }
  


export const getPostAuthForgotpasswordMutationOptions = <TError = ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthForgotpassword>>, TError,{data: EmailApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthForgotpassword>>, TError,{data: EmailApiContract}, TContext> => {

const mutationKey = ['postAuthForgotpassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthForgotpassword>>, {data: EmailApiContract}> = (props) => {
          const {data} = props ?? {};

          return  postAuthForgotpassword(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthForgotpasswordMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthForgotpassword>>>
    export type PostAuthForgotpasswordMutationBody = EmailApiContract
    export type PostAuthForgotpasswordMutationError = ErrorDescription | ErrorApiOutContract

    /**
 * @summary Send forgot password email
 */
export const usePostAuthForgotpassword = <TError = ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthForgotpassword>>, TError,{data: EmailApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthForgotpassword>>,
        TError,
        {data: EmailApiContract},
        TContext
      > => {

      const mutationOptions = getPostAuthForgotpasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | PasswordDetectedInBreach | Password detected in breach and must be changed |
| 400 | TokenNotValid | Invalid token |
| 429 | TooManyRequests | Too many requests, wait before trying again |
| 400 | PasswordNotValid | Password does not meet complexity requirements |
 * @summary Reset password
 */
export const putAuthResetpassword = (
    tokenWithPasswordApiContract: TokenWithPasswordApiContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/auth/resetpassword`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: tokenWithPasswordApiContract
    },
      options);
    }
  


export const getPutAuthResetpasswordMutationOptions = <TError = ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAuthResetpassword>>, TError,{data: TokenWithPasswordApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putAuthResetpassword>>, TError,{data: TokenWithPasswordApiContract}, TContext> => {

const mutationKey = ['putAuthResetpassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAuthResetpassword>>, {data: TokenWithPasswordApiContract}> = (props) => {
          const {data} = props ?? {};

          return  putAuthResetpassword(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAuthResetpasswordMutationResult = NonNullable<Awaited<ReturnType<typeof putAuthResetpassword>>>
    export type PutAuthResetpasswordMutationBody = TokenWithPasswordApiContract
    export type PutAuthResetpasswordMutationError = ErrorDescription | ErrorApiOutContract

    /**
 * @summary Reset password
 */
export const usePutAuthResetpassword = <TError = ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAuthResetpassword>>, TError,{data: TokenWithPasswordApiContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAuthResetpassword>>,
        TError,
        {data: TokenWithPasswordApiContract},
        TContext
      > => {

      const mutationOptions = getPutAuthResetpasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    